export default {
  'footer.tagline':
    'One platform. A world of possibilities. Connecting talents, opportunities and businesses to build a limitless future.',
  'footer.ecosystem': 'Ecosystem',
  'footer.information': 'Information',
  'footer.contact': 'Contact',
  'footer.about': 'About',
  'footer.terms': 'Terms of Use',
  'footer.privacy': 'Privacy Policy',
  'footer.legal': 'Legal Notice',
  'footer.careers': 'Careers',
  'footer.email': 'contact@worldapeiron.com',
  'footer.phone': '+228 97 98 58 49',
  'footer.location': 'Lomé, Togo',
  'footer.rights': 'All rights reserved.',
};